import { IconButton, Menu } from '@zillow/constellation-10';
import { IconMoreFilled } from '@zillow/constellation-icons';

import type { FC } from 'react';

type TourCardEditableControlsProps = {
  onRemoveTour: () => void;
  onViewTour: () => void;
};

const TourCardEditableControls: FC<TourCardEditableControlsProps> = ({ onRemoveTour, onViewTour }) => (
  <Menu
    trigger={
      <IconButton
        title="Tour options"
        tone="brand"
        emphasis="bare"
        icon={<IconMoreFilled />}
        data-testid="TourCardEditableControls-MenuTrigger"
      />
    }
    content={
      <>
        <Menu.Item onClick={onViewTour} data-testid="TourCardEditableControls-ViewTour">
          View
        </Menu.Item>
        <Menu.Item onClick={onRemoveTour} data-testid="TourCardEditableControls-DeleteTour">
          Remove
        </Menu.Item>
      </>
    }
  />
);

export type { TourCardEditableControlsProps };
export default TourCardEditableControls;
